import { styled, useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

import Icon from 'src/@core/components/icon/index'

import { useTranslationWithKey } from 'src/hooks/useTranslationWithKey'

import { IconWrapper } from 'src/components/customer/courses/course-details/LessonStatusMark'

import { LockReason } from 'src/types/courses/access'

const AvailabilityTag = styled(Typography)(({ theme }) => ({
  whiteSpace: 'nowrap',
  padding: theme.spacing(1.25, 2.5, 1.25, 2.5),

  // backgroundColor: theme.colorWithOpacity(theme.palette.text.secondary, 16),
  // color: theme.palette.text.secondary,
  borderRadius: theme.spacing(1.5),
  alignSelf: 'center'
}))

type LessonLockReasonProps = {
  lockReason?: LockReason | null
}

export const LessonLockReason = ({ lockReason = null }: LessonLockReasonProps) => {
  const theme = useTheme()
  const { t } = useTranslationWithKey('translation', { keyPrefix: 'PAGE.CUSTOMER_COURSE' })

  if (lockReason?.type === 'launch_date') {
    const availableDate = new Date(lockReason?.available_at || Date.now())
    const now = new Date()
    const diffInMs = availableDate.getTime() - now.getTime()
    const days = Math.ceil(diffInMs / 1000 / 3600 / 24)
    const count = Math.max(0, days)

    return (
      <>
        <AvailabilityTag
          variant='body2'
          color={theme.palette.text.secondary}
          bgcolor={theme.colorWithOpacity(theme.palette.text.secondary, 16)}
        >
          {t(count === 1 ? 'BUTTONS.available_in_one_day' : 'BUTTONS.available_in_days', {
            count
          })}
        </AvailabilityTag>

        <IconWrapper>
          <Icon icon='tabler:lock' />
        </IconWrapper>
      </>
    )
  }

  if (lockReason?.type === 'quiz') {
    return (
      <>
        <AvailabilityTag
          variant='body2'
          color={theme.palette.primary.main}
          bgcolor={theme.colorWithOpacity(theme.palette.primary.main, 16)}
        >
          {t('blocked_by_quiz_label')}
        </AvailabilityTag>

        <IconWrapper>
          <Icon icon='tabler:lock' />
        </IconWrapper>
      </>
    )
  }

  if (lockReason?.type === 'lesson') {
    return (
      <>
        <AvailabilityTag
          variant='body2'
          color={theme.palette.primary.main}
          bgcolor={theme.colorWithOpacity(theme.palette.primary.main, 16)}
        >
          {t('blocked_by_lesson_label')}
        </AvailabilityTag>

        <IconWrapper>
          <Icon icon='tabler:lock' />
        </IconWrapper>
      </>
    )
  }

  if (lockReason?.type === 'locked' || lockReason?.type === 'expired') {
    return (
      <IconWrapper>
        <Icon icon='tabler:lock' />
      </IconWrapper>
    )
  }

  return null
}
